import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { classnames, classname } from 'utils';

import './Heading.css';

/**
 * Заголовок
 */
class Heading extends Component {
  cl = classname('heading');

  static propTypes = {
    /** Доп. класс */
    className: PropTypes.string,
    /** Название*/
    children: PropTypes.string.isRequired
  };

  render() {
    const { className, children } = this.props;

    const classes = classnames(className, this.cl());

    return <div className={classes}>{children}</div>;
  }
}

export default Heading;
